import { useFetchUser } from '@/features/authorization/api/useFetchUser'
import { ChartBlock, JobsTooltip, Period } from '@/ui-kit'
import { useState } from 'react'
import { useFetchUserJobs } from '../api/useFetchUserJobs'

export function JobsChartBlock(): React.JSX.Element {
  const [jobsPeriod, setJobsPeriod] = useState<Period>('day')
  const { data: user } = useFetchUser(true)
  const { data: nonRestrictedJobs } = useFetchUserJobs(jobsPeriod)

  const targetDate = user ? { title: 'Account was created', date: user.createdAt } : undefined

  return (
    <ChartBlock
      title={{ plural: 'Jobs', singular: 'Job' }}
      data={nonRestrictedJobs}
      period={jobsPeriod}
      onPeriodChange={setJobsPeriod}
      targetDate={targetDate}
      tooltipNode={JobsTooltip as any}
    />
  )
}
